/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDE2VjBIMTZWMTZIMFpNMSAxNUgxNVYxSDFWMTVaTTYuNDUgOC43NEw5LjUyIDQuNjNMMTQuNDMgMTJIMS42OUw0LjM2IDYuNjZMNi40NSA4Ljc0Wk02LjU2IDEwLjI2TDQuNjQgOC4zNEwzLjMxIDExSDEyLjU3TDkuNDggNi4zNkw2LjU2IDEwLjI2Wk02IDVDNi41NTIyOCA1IDcgNC41NTIyOCA3IDRDNyAzLjQ0NzcyIDYuNTUyMjggMyA2IDNDNS40NDc3MiAzIDUgMy40NDc3MiA1IDRDNSA0LjU1MjI4IDUuNDQ3NzIgNSA2IDVaIiBmaWxsPSJpbmhlcml0Ii8+";